// =============================================================================
// paginaPtmstr.js 
// =============================================================================
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';

export function paginaPtmstr() {

    const html = `
        <div class="container-fluid"> 
            <div id="estado-contenedor" class="alert alert-info" role="alert" style="display: none;">
                <p id="mensaje-estado" class="mb-0">Cargando datos del servidor...</p>
            </div>

            <div class="table-responsive">
                <table id="tabla-ptmstr" class="table table-striped table-hover w-100">
                    <thead class="table-light">
                        <tr>
                            <th>Articulo</th>
                            <th>Descripción</th>
                            <th>UM</th>
                            <th>Linea de Prod</th>
                            <th>Grupo</th>
                            <th>Promo</th>
                            <th>Status</th>
                            <th>Comprador</th>
                            <th>Dibujo</th>
                            <th>Estilo</th>
                            <th>Presentación</th>
                            <th>Longitud</th>
                            <th>Color</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>   
        </div>

        <div class="modal fade modal-ice" id="modalDetalleICE" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-secondary text-white">
                        <h5 class="modal-title fw-bold">Detalle ICE</h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="table-responsive">
                            <table id="tabla-ice" class="table table-borderless mb-0">
                                <thead class="table-primary">
                                    <tr>
                                        <th class="ps-3 py-2">Concepto</th>
                                        <th class="text-end py-2">Almacén A</th>
                                        <th class="text-end py-2">Almacén B</th>
                                        <th class="text-end pe-3 py-2">Almacén C</th>
                                        <th class="text-end pe-3 py-2">Total</th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    `;

    setTimeout(() => {
        inicializarDataTable();
    }, 100);

    return html;
}

const URL_BASE_API = obtenerUrlBackend('8083');
const URL_API = `${URL_BASE_API}/api/ptmstr`;

const ID_TABLA = '#tabla-ptmstr';
let datosICE = []; 

function inicializarDataTable() {
    if ($.fn.DataTable.isDataTable(ID_TABLA)) {
        $(ID_TABLA).DataTable().destroy();
    }

    const columnasDef = [
        { 
            data: 'pt_part', 
            name: 'pt_part',
            title: 'Articulo',
            className: 'columna-idptmstr', 
            searchable: true,
            width: '200px',
            render: function (data) {
                return `<a href="#" class="detalle-ptmstr text-decoration-none" data-id="${data}" data-bs-toggle="modal" data-bs-target="#modalDetalleICE">${data}</a>`;
            }
        },
        { data: 'pt_desc', name: 'pt_desc', title: 'Descripción', className: 'text-start', searchable: true, width: '350px' },
        { data: 'pt_um', name: 'pt_um', title: 'UM', searchable: true, width: '70px' },
        { data: 'pt_prod_line', name: 'pt_prod_line', title: 'Linea de Prod', searchable: true, width: '120px' },
        { data: 'pt_grupo', name: 'pt_grupo', title: 'Grupo', searchable: true, width: '120px' },
        { data: 'pt_producto', title: 'Producto', searchable: false, width: '80px' },
        { data: 'pt_status', title: 'Status', searchable: false, width: '80px' },
        { data: 'pt_buyer', title: 'Comprador', searchable: false, width: '100px' },
        { data: 'pt_muestra', title: 'Dibujo', searchable: false, width: '100px' },
        { data: 'pt_estilo', title: 'Estilo', searchable: false, width: '100px' },
        { data: 'pt_presentacion', title: 'Presentación', searchable: false, width: '120px' },
        { data: 'pt_longitud', title: 'Longitud', searchable: false, width: '100px' },
        { data: 'pt_clave_color', title: 'Color', searchable: false, width: '100px' }
    ];

    const table = $(ID_TABLA).DataTable({
        serverSide: true,     
        processing: true,     
        ajax: {
            url: URL_API,
            type: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token_teresita'),
                'Content-Type': 'application/json'
            },
            error: function(xhr) {
                console.error("Fallo de red en DataTable Server-Side (ptmstr):", xhr);
                mostrarToast('Error al obtener artículos desde el servidor', 'danger');
            }
        },
        columns: columnasDef,
        deferRender: true,
        scrollX: true,        
        autoWidth: false,    
        retrieve: true,

        // ============================================================
        // PERSISTENCIA TOTAL: stateSave + callbacks personalizados
        // ============================================================
        stateSave: true,
        stateDuration: -1,     

        stateSaveCallback: function (settings, data) {
            localStorage.setItem(
                'DataTables_' + settings.sInstance + '_' + location.pathname,
                JSON.stringify(data)
            );
        },

        stateLoadCallback: function (settings) {
            const key = 'DataTables_' + settings.sInstance + '_' + location.pathname;
            const data = localStorage.getItem(key);

            if (data) {
                try {
                    return JSON.parse(data);
                } catch (e) {
                    console.warn('Error al parsear estado guardado:', e);
                }
            }
            return null;
        },

        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        paging: true,
        order: [[0, 'asc']],
        lengthChange: true,
        pageLength: 50,
        lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
        dom: '<"row mb-3 align-items-center" <"col-sm-6"B> <"col-sm-6 text-end"l> >rt<"row" <"col-sm-6"i> <"col-sm-6"p> >',
        buttons: [
            { 
                extend: 'colvis', 
                text: '<i class="fas fa-binoculars fa-lg"></i> Columnas', 
                className: 'btn btn-sm',
                postfixButtons: [
                    { 
                        extend: 'colvisRestore',
                        text: '<i class="fas fa-eye"></i> Mostrar Todas',
                        action: function (e, dt, node, config) {
                            // Restaurar visibilidad
                            $.fn.dataTable.ext.buttons.colvisRestore.action.call(this, e, dt, node, config);
                            // Mostrar todas las columnas
                            dt.columns().visible(true);
                            // Guardar estado 
                            dt.state.save();
                            // Ajustar columnas
                            setTimeout(function() {
                                dt.columns.adjust().draw(false);
                            }, 100);
                        }
                    }
                ]
            },            
            {
                extend: 'collection',
                text: '<i class="fas fa-download"></i> Exportar', 
                className: 'btn btn-sm', 
                buttons: [
                    { extend: 'copy', text: '<i class="fas fa-copy"></i> Copiar', exportOptions: {columns: ':visible'} },
                    { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', exportOptions: {columns: ':visible'} },
                    { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', orientation: 'landscape', exportOptions: {columns: ':visible'} },
                    { extend: 'print', text: '<i class="fas fa-print"></i> Imprimir', exportOptions: {columns: ':visible'} }
                ]
            },
            {
                text: '<i class="fas fa-filter"></i> Limpiar Filtros', 
                className: 'btn btn-sm',
                action: function (e, dt) {
                    $('.filtro-columna').val('');
                    dt.columns().every(function () {
                        this.search(''); 
                    });
                    dt.search('').draw();
                    dt.state.save();         
                    mostrarToast('Filtros limpiados', 'info');
                }
            }
        ],

        // ============================================================
        // INIT COMPLETE: Crear inputs y restaurar filtros de texto
        // ============================================================
        initComplete: function () {
            var columnasFiltrables = [0, 1, 2, 3, 4]; 
            var api = this.api();
            var estadoCargado = api.state.loaded();

            columnasFiltrables.forEach(function (idx) {
                var column = api.column(idx);
                var headerCelda = $(column.header());

                // Previene duplicidades si se vuelve a ejecutar initComplete
                if (headerCelda.find('.filtro-container-celda').length > 0) {
                    return;
                }

                var title = api.settings()[0].aoColumns[idx].sTitle || headerCelda.first().text(); 

                var container = $('<div class="filtro-container-celda mt-1"></div>');
                var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="Filtrar ' + title + '" style="font-weight: normal;" />');

                // RESTAURAR EL TEXTO GUARDADO EN EL ESTADO
                if (estadoCargado && estadoCargado.columns && estadoCargado.columns[idx] && estadoCargado.columns[idx].search) {
                    var valorGuardado = estadoCargado.columns[idx].search.search;
                    if (valorGuardado) {
                        input.val(valorGuardado);
                    }
                }

                input.appendTo(container);
                headerCelda.append(container);

                // Evita que hacer clic en la caja altere el ordenamiento de la columna
                input.on('click', function (e) {
                    e.stopPropagation();
                });

                input.on('keydown', function (e) {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        $(this).trigger('change');
                    }
                });

                input.on('keyup change clear', function () {
                    var valor = this.value;
                    clearTimeout(column.filtroTimeout);
                    column.filtroTimeout = setTimeout(function() {
                        if (column.search() !== valor) {
                            column.search(valor).draw();
                        }
                    }, 400);
                });
            });

            // ============================================================
            // FASE 2: APLICAR FILTROS RESTAURADOS EN SERVER-SIDE
            // ============================================================
            if (estadoCargado) {
                var necesitaRedraw = false;

                columnasFiltrables.forEach(function (idx) {
                    var column = api.column(idx);
                    if (estadoCargado.columns && estadoCargado.columns[idx] && estadoCargado.columns[idx].search) {
                        var valor = estadoCargado.columns[idx].search.search;
                        if (valor && column.search() !== valor) {
                            column.search(valor);
                            necesitaRedraw = true;
                        }
                    }
                });

                // Si hay búsqueda global guardada
                if (estadoCargado.search && estadoCargado.search.search) {
                    var searchGlobal = estadoCargado.search.search;
                    if (api.search() !== searchGlobal) {
                        api.search(searchGlobal);
                        necesitaRedraw = true;
                    }
                }

                if (necesitaRedraw) {
                    api.draw();
                }
            }
        }
    });

    $(ID_TABLA).off('click', '.detalle-ptmstr').on('click', '.detalle-ptmstr', function (e) {
        e.preventDefault();
        const articuloId = $(this).data('id'); 
        const urlDinamicaICE = `${URL_BASE_API}/api/datosIce/${articuloId}`;
        obtenerDatosICE(urlDinamicaICE, articuloId);
    });
}

async function obtenerDatosICE(url, articuloId) {
    try {
        const token = sessionStorage.getItem('token_teresita');
        const respuesta = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (!respuesta.ok) throw new Error(`Error ${respuesta.status}`);
        const datos = await respuesta.json();
        if (!datos || datos.length === 0) {
            mostrarToast('No hay datos ICE.', 'warning');
            return;
        }
        datosICE = datos;
        inicializarDataICE(datosICE);
    } catch (error) {
        console.error("Error al obtener ICE:", error);
        mostrarToast(error.message, 'warning');
    }
}

function inicializarDataICE(datos) {
    const ID_TABLA_ICE = '#tabla-ice';
    if ($.fn.DataTable.isDataTable(ID_TABLA_ICE)) {
        $(ID_TABLA_ICE).DataTable().destroy();
    }
    $(ID_TABLA_ICE).find('tbody').empty();

    const columnasDef = [
        { data: 'concepto', title: 'Concepto', className: 'ps-3' },
        { data: 'a', title: 'Almacén A', className: 'text-end', render: data => formatearValorICE(data) },
        { data: 'b', title: 'Almacén B', className: 'text-end', render: data => formatearValorICE(data) },
        { data: 'c', title: 'Almacén C', className: 'text-end pe-3', render: data => formatearValorICE(data) },
        { data: 'total', title: 'Total', className: 'text-end pe-3', render: data => formatearValorICE(data) }
    ];

    $(ID_TABLA_ICE).DataTable({
        data: datos,
        columns: columnasDef,
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        autoWidth: false,
        responsive: true,
        language: { url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json" },
        dom: 't',
        createdRow: function(row, data) {
            const concepto = (data.concepto || '').toLowerCase();
            if (concepto.includes('inventario total') || concepto.includes('otras entradas') || concepto.includes('otras salidas') || concepto.includes('saldo ice')) {
                $(row).addClass('table-primary fw-bold text-dark');
            } else if (concepto.includes('subtotal') || concepto === '') {
                $(row).addClass('fw-bold border-top');
            } else if (concepto.startsWith('-') || concepto.startsWith('+')) {
                $(row).addClass('text-muted');
            }
        }
    });
}

function formatearValorICE(valor) {
    if (valor === null || valor === undefined || valor === '' || valor === '-') return '-';
    const num = parseFloat(valor);
    if (isNaN(num)) return valor;
    return num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
